import React, { useEffect } from 'react'
import styles from './CategoryMediaSelect.module.scss'
import cx from 'classnames'
import CategoryTree from './CategoryTree'
import { useTranslation } from 'react-i18next'
import { useFetchData } from '../../../../hooks/useFetchData'
import { StoredMediaCategory } from '../../../../types/Media'
import Heading from '../../../../components/Heading'
import Loader from '../../../../components/Loader'
import CreateCategoryModal from '../../CategorySettings/CreateCategoryModal'
import { ApiRoutes } from '../../../../services/ApiService'

type CategoryMediaSelectProps = {
    selectedCategoryIds: number[]
    onToggle: (categoryId: number, tree: StoredMediaCategory[]) => void
    enableAddNewCategory?: boolean
}

const CategoryMediaSelect: React.FC<CategoryMediaSelectProps> = ({
    selectedCategoryIds,
    onToggle,
    enableAddNewCategory,
}) => {
    const { t } = useTranslation(['settings'])

    const {
        data: categories,
        isLoading,
        fetch,
    } = useFetchData<StoredMediaCategory>(ApiRoutes.MEDIA_CATEGORIES)

    const toggleCategory = (value: number) => {
        onToggle(value, categories)
    }

    const handleNewCategory = (newCategoryId: number) => {
        onToggle(newCategoryId, categories)
        fetch()
    }

    useEffect(() => {
        fetch()
    }, [fetch])

    return (
        <div className={cx(styles['zr-tree-content-wrapper'])}>
            <Heading classes={'zr-mb-4'} level={4}>
                {t('media.category_select.heading')}
            </Heading>
            <div className={cx(styles['category-tree'])}>
                {!isLoading && categories.length > 0 ? (
                    <CategoryTree
                        parent={null}
                        tree={categories}
                        toggleCategory={toggleCategory}
                        selectedCategoryIds={selectedCategoryIds}
                    />
                ) : isLoading ? (
                    <div
                        className={
                            'zr-d-flex zr-justify-center zr-w-100 zr-h-100 zr-items-center'
                        }
                    >
                        <Loader size={'m'} isLoading={isLoading} />
                    </div>
                ) : (
                    <div
                        style={{ color: '#aaa' }}
                        className={
                            'zr-d-flex zr-justify-center zr-w-100 zr-items-center'
                        }
                    >
                        {t('media.category_select.no_categories')}
                    </div>
                )}
            </div>
            {enableAddNewCategory && (
                <CreateCategoryModal
                    categories={categories}
                    onNewCategory={(newCategoryId) =>
                        handleNewCategory(newCategoryId)
                    }
                />
            )}
        </div>
    )
}

export default CategoryMediaSelect
